import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getMesaByToken } from '../services/api';
import { useCarrinho } from '../services/CarrinhoContext';
import Cardapio from './Cardapio';
import Loading from '../components/Loading';

function TabletTokenDaMesa({ brand }) {
  const { token } = useParams();
  const { setMesa, setTipoEntrega } = useCarrinho();
  const [mesaData, setMesaData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (brand && token) {
      carregarMesa();
    }
  }, [brand, token]);

  const carregarMesa = async () => {
    try {
      setLoading(true);
      const cleanToken = token.replace(/[^a-zA-Z0-9]/g, '');
      
      const resultado = await getMesaByToken(brand, cleanToken);
      
      if (!resultado) {
        setError('Mesa não encontrada');
        return;
      }

      setMesaData(resultado);
      setMesa(resultado);
      setTipoEntrega('local');
      
    } catch (error) {
      setError('Erro ao carregar dados da mesa');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <Loading message="Carregando mesa..." />;
  }

  if (error) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-danger">
          <h4>Erro</h4>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  if (!mesaData) {
    return (
      <div className="container mt-5 text-center">
        <div className="alert alert-warning">
          <h4>Mesa não encontrada</h4>
        </div>
      </div>
    );
  }

  return <Cardapio brand={brand} mesaData={mesaData} />;
}

export default TabletTokenDaMesa;
